var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoRedOutlineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 6.41667H11.9167V8.25H10.0833V6.41667Z",
    fill: "#F95055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 10.0833H11.9167V15.5833H10.0833V10.0833Z",
    fill: "#F95055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 11C1.83333 5.94 5.93998 1.83333 11 1.83333C16.06 1.83333 20.1667 5.94 20.1667 11C20.1667 16.06 16.06 20.1667 11 20.1667C5.93998 20.1667 1.83333 16.06 1.83333 11ZM3.66667 11C3.66667 15.0425 6.95747 18.3333 11 18.3333C15.0425 18.3333 18.3333 15.0425 18.3333 11C18.3333 6.9575 15.0425 3.66667 11 3.66667C6.95747 3.66667 3.66667 6.9575 3.66667 11Z",
    fill: "#F95055"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRedOutlineIcon);
export default __webpack_public_path__ + "static/media/info-red-outline-icon.515d8cbdec519f4efb25009ee4294119.svg";
export { ForwardRef as ReactComponent };